import React, { useCallback, useEffect, useState } from "react";
import "./Sliders.css";

export const TYPES = [ "default", "knob", "radio", "time" ];


function Default({
    minValue = 0,
    maxValue = 1,
    value, 
    step = 0.1,
    disableInput = false,
    sections = [],
    snapToSections = false,
    onSectionChange = undefined,
    onValueChange = undefined,
    renderValue = (value) => value,
    setValue,
    round = 2,
    type
}) {
    const [ref, setRef] = useState();

    let lastSection = minValue;
    if (sections && sections.filter(it => ! isNaN(it)).map(it => Math.max(minValue, Math.min(it, maxValue))).indexOf(maxValue) < 0) sections.push(maxValue);
    if (sections) sections = sections.filter(it => ! isNaN(it)).map(it => Math.max(minValue, Math.min(it, maxValue))).sort().map(it => {
        const out = <span className="yona-sliderSection" key={it} style={{flexGrow: Math.max(0, it - lastSection)}}/>
        lastSection = it;
        return out;
    });

    const relativeMax = (maxValue - minValue);
    let percentage = ((value - minValue) / relativeMax) * 100;
    let roundedValue = Math.round(value * (10 ** round)) / (10 ** round);

    const [isDown, setDown] = useState(false);
    const dragStart = e => { setDown(true) };
    const dragEnd = () => { setDown(false) };
    const dragMove = useCallback(e => {
        if (! (ref && ref.getAttribute("data-down") === "true")) return;
        if (e.cancelable) e.preventDefault();
        const relativeX = (e.pageX || e.touches[0].pageX) - ref.offsetLeft;
        
        let newValue = Math.min(Math.max((relativeX / ref.offsetWidth) * relativeMax + minValue, minValue), maxValue);
        setValue(newValue);
    }, [ref, minValue, maxValue, relativeMax, setValue]);

    useEffect(() => {
        if (! ref) return;
        const mm = document.body.addEventListener("mousemove", dragMove);
        const mu = document.body.addEventListener("mouseup", dragEnd);
        return () => {
            document.body.removeEventListener("mousemove", mm);
            document.body.removeEventListener("mouseup", mu);
        };
    }, [ref, dragMove]);


    return <div
        className={`yona-sliderWrapper${type === "knob" ? " knob" : ""}`}
        ref={setRef}
        onTouchMove={dragMove}
        data-down={isDown}
        >
        
        <div className="yona-sliderSectionWrapper">
            {sections || <></>}
        </div>
        <span 
            className="yona-sliderKnob" 
            style={{ left: percentage + "%" }}
            onMouseDown={dragStart}
            onMouseUp={dragEnd}
            onTouchStart={dragStart}
            onTouchEnd={dragEnd}
        >
            <span draggable="false" className="yona-sliderLabel">{renderValue(roundedValue)}</span>
        </span>
    </div>;
}


export default function Slider(props) {
    let { 
        minValue = 0,
        maxValue = 1,
        value,
        type = TYPES[0],
        id,
        round = 2,
        setValue,
    } = props;

    if (! value) value = (maxValue - minValue) / 2 + minValue;
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        if (setValue) setValue(internalValue);
    }, [internalValue, setValue]);
    useEffect(() => {
        setInternalValue(value)
    }, [value]);

    let roundedValue = Math.round(internalValue * (10 ** round)) / (10 ** round);

    type = type.toLocaleLowerCase();
    let slider;
    switch (type) {
        case "knob": slider = Default({ ...props, value: internalValue, setValue: setInternalValue }); break;
        case "radio": break;
        case "time": break;
        default: slider = Default({ ...props, value: internalValue, setValue: setInternalValue });
    }
    return (<>
        <input readOnly type="range" min={minValue} max={maxValue} value={roundedValue} className="yona-hidden" id={id} />
        {slider}
    </>);
}